module.exports = __webpack_public_path__ + "0-es2015.6e3eef8e865af98879e0.worker.js"